

export const permisosData = [
    { permiso: 1, label: 'Administrador', menu: 'Admin' },
    { permiso: 2, label: 'Usuario Área', menu: 'Catálogos' },
];